import React from 'react'

export const Text = React.memo(({children, ...otherProps}) =>{
    return(
        <p {...otherProps}>{children}</p>
    )
})